import React from 'react';
import { ReactComponent as MinusIcon } from '../../../../components/Common/BootstrapIcons/dash.svg';
import { ReactComponent as PlusIcon } from '../../../../components/Common/BootstrapIcons/plus.svg';
import './ValidationSection.scss';
import ReportConfig from '../../../../types/report/ReportConfig';
import NameAndNumber from '../../../../types/report/NameAndNumber';
import SearchByFor from '../../../Common/AutocompleteInput/SearchByFor';
import httpClient from '../../../../infrastructure/helpers/common/httpClient';
import urlHelper from '../../../../infrastructure/helpers/common/urlHelper';
import CustomIcon from '../../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../../Common/BootstrapIcons/Tooltip/IconTooltip';
import navigationHelper from '../../../../infrastructure/helpers/common/navigation/navigation';
import messageHelper from '../../../Common/Message/MessageHelper';
import { ReactComponent as DownloadIcon } from '../../../../components/Common/BootstrapIcons/download.svg';
import { ReactComponent as UploadIcon } from '../../../../components/Common/BootstrapIcons/upload.svg';
import UploadFileModal from '../../../Common/Modals/UploadFileModal/UploadFIleModal';

interface Props {
    heading: string;
    htmlId: string;
    onClick: (htmlId: string) => void;
    isExpanded: (htmlId: string) => boolean;
    regime: string;
    validationKind: string;
    reportConfig: ReportConfig,
    sectionId: string;
    isReadOnly: boolean;
    onSearchBySelected: (value: string) => void;
    getOptions: (value: string) => NameAndNumber[];
    onClearClick: () => void;
    searchByOptions: string[];
    onSearch: (options: NameAndNumber[], value: string, searchBy: string) => void;
}

interface State {
    showFileUploadPopup: boolean,
    showSearchPopup: boolean,
    searchBy: string,
    searchForValue: string,
    showSearchSpinner: boolean,
    searchValue: string
}

const defaultSearchByOption = 'Search By ';
class ValidationSection extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);

        this.state = {
            showFileUploadPopup: false,
            showSearchPopup: false,
            searchBy: defaultSearchByOption,
            searchForValue: '',
            showSearchSpinner: false,
            searchValue: '',
        }

        this.onClick = this.onClick.bind(this);
        this.onDownloadValidationsClick = this.onDownloadValidationsClick.bind(this);
        this.onUploadValidationsClick = this.onUploadValidationsClick.bind(this);
        this.onValidationsUpdated = this.onValidationsUpdated.bind(this);
    }

    onValidationsUpdated() {
        navigationHelper.refreshPage();

        let message = 'Bulk update completed. Please change history.';

        messageHelper.showMesage(message, true);
    }

    async onUploadFilePicked(files: FileList, validationKind: string): Promise<void> {

        let data = this.getUploadData(files[0]);

        var path = urlHelper.buildRoute(['report', 'validations', validationKind, this.props.reportConfig.regime]);

        await httpClient.postFile(path, data, {});

        this.setState({ showFileUploadPopup: false }, this.onValidationsUpdated);
    }

    onUploadValidationsClick(validationKind: string) {
        this.setState({ showFileUploadPopup: true });
    }

    getUploadData(file: File): FormData {
        let data = new FormData();

        data.append('file', file as File);

        return data;
    }

    onClick(): void {
        this.props.onClick(this.props.htmlId);
    }

    getClassName(): string {
        let classes = ['collapse'];

        if (this.props.isExpanded(this.props.htmlId)) {
            classes.push('show');
        }

        return classes.join(' ');
    }

    resolveIcon(): JSX.Element {

        return this.props.isExpanded(this.props.htmlId) ? <MinusIcon /> : <PlusIcon />;
    }

    resolveTooltip(): string {

        return this.props.isExpanded(this.props.htmlId) ? 'collapse' : 'expand';
    }

    getItem(actionItem: string) {
        return { id: actionItem, name: actionItem, item: actionItem, preventDelete: false };
    }

    async onDownloadValidationsClick(validationKind: string) {

        let route = urlHelper.buildRoute(['report', 'validations', validationKind, this.props.reportConfig.regime]);

        await httpClient.download(route);

        this.setState({ showFileUploadPopup: false });
    }

    render(): JSX.Element {

        return (
            <>
                <div className="section-heading" style={{ paddingLeft: '25px' }}>
                    <div>
                        <div className='width-250px display-flex'>
                            <h5 id={this.props.htmlId}>
                                {this.props.heading}
                            </h5>
                            <button id={`btn-expand-${this.props.htmlId}`} className="transparent-button" onClick={this.onClick} title={this.resolveTooltip()}>
                                {this.resolveIcon()}
                            </button>
                        </div>
                        {this.props.isExpanded(this.props.htmlId) &&
                            <div className='display-flex'>
                                <SearchByFor
                                    inpuClassName='section-search'
                                    searchByClassName='section-search'
                                    searchByOptions={this.props.searchByOptions || []}
                                    getOptions={(searchBy: string) => this.props.getOptions(searchBy)}
                                    onSearchByChange={(value: string) => this.props.onSearchBySelected && this.props.onSearchBySelected(value)}
                                    onSearch={(options: NameAndNumber[], value: string, searchBy: string) => this.props.onSearch && this.props.onSearch(options, value, searchBy)}
                                    onClearClick={() => {
                                        this.setState({ searchValue: '' }, () =>
                                            this.props.onClearClick && this.props.onClearClick());
                                    }}
                                />
                                <div id='validationsButtons'>
                                    <button type="button" className="bg-none border-none" onClick={() => this.onDownloadValidationsClick(this.props.validationKind)}>
                                        <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                                    </button>
                                    <button type="button" className="bg-none border-none" onClick={() => this.onUploadValidationsClick(this.props.validationKind)}>
                                        <CustomIcon icon={UploadIcon} title={iconTooltip.upload} />
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className={this.getClassName()}>
                    {this.props.children}
                </div>
                {
                    this.state.showFileUploadPopup &&
                    <UploadFileModal
                        allowedExtensions={['csv']}
                        onClose={() => { this.setState({ showFileUploadPopup: false }) }}
                        uniqueName='validationsUpload'
                        onFilePicked={(file: FileList) => this.onUploadFilePicked(file, this.props.validationKind)}
                    />
                }
            </>
        );
    }
}

export default ValidationSection;
